// @flow
import { connect } from 'react-redux';
import type { State, CarEntity } from '../../../types';
import { sessionConfigSelector } from '../../../selectors/configSelectors';
import { makeCarEntityAutoSelector } from '../../../selectors/carSelectors';
import carActions from '../../../actions/carActions';
import SyncCar from '../SyncCar';
import type { Props } from '../SyncCar';

type OwnProps = $ReadOnly<{
    icao: string,
    entity: CarEntity
}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    const carBuffer = makeCarEntityAutoSelector(props.icao)(state);

    return {
        sessionConfig: sessionConfigSelector(state),
        car: carBuffer && carBuffer[0]
    };
};

const mapDispatchToProps = {
    endSession: carActions.endSession
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(SyncCar);